<template>
  <div>
    <el-dialog title="下載專區" :visible.sync="dialogFormVisible">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="車輛車輛出勤表日報表" name="first">
          <el-row>
            <el-date-picker
              v-model="date"
              type="date"
              placeholder="日期"
              @change="changeTime"
            ></el-date-picker>
          </el-row>
          <el-row>
            <InputAutocomplete
              ref="inputAuto1"
              @handleSelect="handleSelect"
              @handleClear="handleClear"
            ></InputAutocomplete>
          </el-row>
          <el-row>
            <DriverLicenseSelector
              :driver="licenseNumber"
              placeholder="注意：英文大寫，所有字母為半形字"
              :preferParams="{
                searchFields: 'license_number',
              }"
              @driver-license-updated="setDriverLicenseFields($event)"
            />
          </el-row>
          <hr />
          <el-row>
            <span>總共{{ totalData }}筆，一次限制100筆下載</span>
          </el-row>
          <el-row>
            <el-select v-model="value" :placeholder="totalPage.toString()">
              <el-option
                v-for="item in totalPage"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="月報表" name="second">
          <el-row>
            <el-date-picker
              v-model="month"
              type="month"
              placeholder="選擇月份"
              @change="changeMonth"
            ></el-date-picker>
          </el-row>
          <el-row>
            <InputAutocomplete
              @handleSelect="handleSelect"
              @handleClear="handleClear"
            ></InputAutocomplete>
          </el-row>
          <el-row>
            <DriverLicenseSelector
              :driver="licenseNumber"
              placeholder="注意：英文大寫，所有字母為半形字"
              :preferParams="{
                searchFields: 'license_number',
              }"
              @driver-license-updated="setDriverLicenseFields($event)"
            />
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="衛生局-批次表" name="third">
          <el-row>
            <el-date-picker
              v-model="health_date"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="结束日期"
              @change="changeTimeForBatch"
            ></el-date-picker>
          </el-row>
          <el-row>
            <DriverLicenseSelector
              :driver="licenseNumberForBatch"
              placeholder="注意：英文大寫，所有字母為半形字"
              :preferParams="{
                searchFields: 'license_number',
              }"
              @driver-license-updated="setDriverLicenseForBatchFields($event)"
            />
          </el-row>

          <!-- <el-row>
            <el-button @click="downloadLongTermInfo">下載長照單資訊</el-button>
          </el-row> -->
        </el-tab-pane>
        <el-tab-pane label="下載長照單" name="fourth">
          <el-row>
            <el-date-picker
              v-model="bill_date"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="结束日期"
              @change="changeTimeForBill"
            ></el-date-picker>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="download" :loading="loading">
          下 載
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import longTermCareService from '@/API/longTermCareService'
import InputAutocomplete from './InputAutocomplete'
import DriverLicenseSelector from '../../pages/longTermCare/DriverLicenseSelector'
import moment from 'moment'
import axios from 'axios'
import API from '../../assets/js/libs/API'
import { cookies } from '@/utils/cookies'

export default {
  props: ['driverList', 'licenceList'],
  components: {
    InputAutocomplete,
    DriverLicenseSelector,
  },
  data() {
    return {
      loading: false,
      activeName: 'first',
      dialogFormVisible: false,
      date: '',
      totalData: 0,
      totalPage: 0,
      startDate: '',
      endDate: '',
      driverId: null,
      licenseNumber: null,
      licenseNumberForBatch: '',
      value: null,
      driverName: null,
      month: '',
      health_date: null,
      bill_date: null,
      month_report: {
        year: '',
        month: '',
      },
      month_batch_table: {
        start: null,
        end: null,
      },
      bill_table: {
        start: null,
        end: null,
      },
    }
  },
  methods: {
    downloadLongTermInfo() {
      let api = `${API.getAPIUrl}long_term_care/order/excel/order_detail_report?start_date=${this.bill_table.start}&end_date=${this.bill_table.end}`
      axios
        .get(api, {
          responseType: 'blob',
          headers: {
            'x-access-token': cookies.get('user'),
          },
        })
        .then((res) => {
          // if(!res.success) throw new RangeError(res.error.message)
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob)
          downloadElement.download = `${this.bill_table.start}~${this.bill_table.end}長照單.xls`
          downloadElement.href = href
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
        .catch((error) => {
          console.log(error)
          this.$msg('下載失敗，目前無訂單')
        })
    },
    setDriverLicenseForBatchFields(val) {
      this.licenseNumberForBatch = val
      console.log(val)
      // this.searchDateInfo(this.driverName, this.licenseNumber)
    },
    resetData() {
      this.startDate = ''
      this.endDate = ''
      this.date = ''
      this.loading = false
      this.health_date = null
      this.bill_date = null
      this.totalData = 0
      this.totalPage = 0
      this.activeName = 'first'
      this.month_batch_table.start = null
      this.month_batch_table.end = null
      this.month_report.year = null
      this.month_report.month = null
      this.driverName = null
      this.licenseNumber = null
      this.driverId = null
      this.month = ''
      // this.$refs.inputAuto1.clearSelect()
    },
    handleClick(tab, event) {
      console.log(tab)
      this.resetData()
      this.activeName = tab.paneName
    },
    handleClear() {
      this.driverName = null
      this.licenseNumber = null
      this.driverId = null
    },
    openDialog() {
      this.resetData()
      this.dialogFormVisible = !this.dialogFormVisible
    },
    changeTime(val) {
      console.log(val)
      this.startDate = moment(val).format('YYYY-MM-DD')
      this.endDate = moment(val).add(24, 'hour').format('YYYY-MM-DD')
      console.log(this.startDate)
      console.log(this.endDate)

      this.searchDateInfo('', '')
    },
    searchDateInfo(driverName, licence) {
      this.totalData = 0
      this.totalPage = 0
      longTermCareService
        .searchDateAndDriveInfo(
          this.startDate,
          this.endDate,
          driverName,
          licence,
        )
        .then((raw) => {
          console.log(raw.result)
          this.totalPage = raw.result.paging.totalPages
          this.totalData = raw.result.paging.totalEntries
        })
    },
    handleSelect(val) {
      this.$set(this, 'licenseNumber', val.licence)
      this.driverName = val.name
      this.driverId = val.id
      this.searchDateInfo(this.driverName, this.licenseNumber)
      // this.getDriverWithdrawalBillList()
    },
    setDriverLicenseFields(val) {
      console.log(val)
      this.licenseNumber = val
      this.searchDateInfo(this.driverName, this.licenseNumber)
    },
    download() {
      if (this.activeName === 'fourth') {
        this.downloadLongTermInfo()
        return
      }
      let api = ''
      const downloadElement = document.createElement('a')
      if (this.activeName === 'first') {
        if (this.driverId === null) return this.$msg('選擇司機')
        if (this.licenseNumber === null) return this.$msg('填入車牌')
        let startTime = this.startDate
        let endTime = this.endDate
        downloadElement.download = `${startTime}~${endTime}統計長照單.xls`
        api = `${API.getAPIUrl}long_term_care/order/excel/daily_report?start_date=${this.startDate}&end_date=${this.endDate}&driver_id=${this.driverId}&licence=${this.licenseNumber}&current_page=1`
      } else if (this.activeName === 'second') {
        downloadElement.download = `${this.month_report.year}-${this.month_report.month}月報表.xls`
        let license = ''
        if (this.licenseNumber !== null && this.licenseNumber !== '') {
          license = `&licence=${this.licenseNumber}`
        }
        let driverId = ''
        if (this.driverId !== null && this.driverId !== '') {
          driverId = `&driver_id=${this.driverId}`
        }
        api = `${API.getAPIUrl}long_term_care/order/excel/monthly_report?search_year=${this.month_report.year}&search_month=${this.month_report.month}${driverId}${license}`
      } else if (this.activeName === 'third') {
        downloadElement.download = `${this.month_batch_table.start}~${this.month_batch_table.end}批次表.xls`
        api = `${API.getAPIUrl}long_term_care/order/excel/ministry_of_health?start_date=${this.month_batch_table.start}&end_date=${this.month_batch_table.end}&licence=${this.licenseNumberForBatch}`
      } else {
        return alert('tab 選擇錯誤')
      }
      this.loading = true
      axios
        .get(api, {
          responseType: 'blob',
          headers: {
            'x-access-token': cookies.get('user'),
          },
        })
        .then((res) => {
          // if(!res.success) throw new RangeError(res.error.message)
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })

          const href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.$msg('下載失敗，目前無訂單')
          this.loading = false
        })
    },
    changeMonth(val) {
      console.log(val)
      this.month_report.year = moment(val).format('YYYY')
      this.month_report.month = moment(val).format('MM')
    },
    changeTimeForBatch(val) {
      console.log(val)
      this.month_batch_table.start = moment(val[0]).format('YYYY-MM-DD')
      this.month_batch_table.end = moment(val[1]).format('YYYY-MM-DD')
    },
    changeTimeForBill(val) {
      console.log(val)
      this.bill_table.start = moment(val[0]).format('YYYY-MM-DD')
      this.bill_table.end = moment(val[1]).format('YYYY-MM-DD')
    },
  },
}
</script>
<style scoped>
.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/element_ui/DownloadLongCareDialog.vue